export default __webpack_public_path__ + "static/media/orders-grey.8c54eaa7.svg";